import React, { useEffect } from 'react';
import { QuizFlow } from './components/QuizFlow';
import { initClickMagick } from './lib/clickMagick';
import { initMetaPixel } from './lib/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    initClickMagick();
  }, []);
  return <div className="min-h-screen w-full bg-[#F9F8F6] font-sans" data-id="element-0" data-mp="3fahzoxz3t5d6">
      <QuizFlow data-id="element-1" data-mp="3fb15xhfe65bd" />
    </div>;
}